import { render, staticRenderFns } from "./pincheConfig.vue?vue&type=template&id=0c538182"
import script from "./pincheConfig.vue?vue&type=script&lang=js"
export * from "./pincheConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports